import DefaultBlock from "/scripts/default/block";
import gsap from "gsap";
import MorphSVGPlugin from "gsap/MorphSVGPlugin";

gsap.registerPlugin(MorphSVGPlugin);

export default class CoreAccessibility extends DefaultBlock {
	init() {
		const el = {
			windmill: this.block.querySelector("#core-accessibility-windmill"),
			checkbox: this.block.querySelector("#core-accessibilty-reduced-motion"),
			portrait: this.block.querySelector("#core-accessibility-portrait"),
			landscape: this.block.querySelector("#core-accessibility-landscape"),
			tablet: this.block.querySelector("#core-accessibility-tablet"),
		};
		this.el = el;

		this.mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

		this.setCheckbox();
		this.initAccessibility();
		this.playMotion();
	}

	playMotion() {
		gsap.set([this.el.portrait, this.el.landscape, this.el.tablet], {
			transformOrigin: "50% 50%",
		});

		gsap.set(this.el.windmill, {
			transformOrigin: "50% 50%",
			scale: 0.3,
			opacity: 1,
		});

		let mm = gsap.matchMedia();
		mm.add(
			{
				isNotOK: "(prefers-reduced-motion: reduce)",
				isOk: "(prefers-reduced-motion: no-preference)",
			},
			(context) => {
				let reduceMotion = this.el.checkbox.checked;

				if (!reduceMotion) {
					let tl = gsap.timeline({
						repeat: -1,
						defaults: { duration: 1.2, ease: "back.inOut(1.1)" },
					});
					tl.to(
						this.el.portrait,
						{
							morphSVG: {
								shape: this.el.landscape,
							},
						},
						0
					);

					tl.to(
						this.el.windmill,
						{
							scale: 0.45,
						},
						0
					);

					tl.to(
						this.el.portrait,
						{
							morphSVG: {
								shape: this.el.tablet,
							},
						},
						1.2
					);

					tl.to(
						this.el.windmill,
						{
							scale: 0.9,
						},
						1.2
					);

					tl.to(
						this.el.portrait,
						{
							morphSVG: {
								shape: this.el.portrait,
							},
						},
						2.4
					);

					tl.to(
						this.el.windmill,
						{
							scale: 0.3,
						},
						2.4
					);
				}

				this.tlWindmill = gsap.timeline({
					repeat: -1,
					defaults: {
						ease: "none",
						duration: reduceMotion ? 7.2 : 3.6,
					},
				});

				this.tlWindmill.to(
					this.el.windmill,
					{
						rotation: 360,
					},
					0
				);
			}
		);
	}

	setCheckbox() {
		this.el.checkbox.checked = this.mediaQuery.matches;
	}

	initAccessibility() {
		this.el.checkbox.addEventListener("change", () => {
			gsap.matchMediaRefresh();
		});
	}
}
